import { save, clearMulti } from "../storage";
import { login, getUserInfo } from "./user.api";
import { STORE_KEY_USERINFO } from "../constants";
import { userInfo } from "../stored";

const state = Object.assign({ options: null }, JSON.parse(userInfo));

const mutations = {
  // set user info
  SET_USER_INFO(state, userInfo) {
    // state = userInfo || state;
    state = Object.assign(state, userInfo);
  },
  // after logout
  LOGOUT(state) {
    state.user = "";
    state.name = "";
    state.person = "";
    state.email = "";
    state.phone = "";
    state.auth = false;
  }
};

const actions = {
  // init user info
  loadUserInfo ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then((result) => {
        if (result.access && result.access.length > 0)
        {
          for (let idx = 0; idx<result.access.length; idx++ )
          {
            let rule = result.access[idx];
            if (rule.path.startsWith("/customer/centre"))
            {
              rule.path = rule.path.substring("/customer/centre".length);
              if (rule.path === "")
                rule.path = "/";
            }
          }
        }
        commit("SET_USER_INFO", result);
        save(STORE_KEY_USERINFO, JSON.stringify(result));
        resolve(result);
      }, (error) => {
        console.log("loadUserInfo() rejected", error);
        reject(error);
      });
    });
  },
  // login action
  login({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      login(payload.username, payload.password).then(user => {
          console.log("User " + payload.username + ((user && user.auth)? " authenticated" : " not authenticated, reason " + user.status));
          commit("SET_USER_INFO", user);
          save(STORE_KEY_USERINFO, JSON.stringify(user));
          if (user.auth)
            resolve();
          else
            reject({status : user.status, body: user.body});
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // logout action
  logout({ commit }, payload) {
    commit("LOGOUT");
    clearMulti([STORE_KEY_USERINFO]);
  }
};

const getters = {
  auth(state) {
    return state.auth;
  },
  username(state) {
    return state.user;
  },
  loggedName(state) {
    return state.name;
  },
  loggedIn(state) {
    return !!(state.user && state.auth);
  },
  userInfo(state) {
    return state;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
